const sidebar4 = (editor) => {

    editor.BlockManager.add(`sidebar4`, {
        category: 'Sidebars',
        label: ` 
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="1.4rem" height="1.4rem" viewBox="0 0 128.000000 128.000000"
                preserveAspectRatio="xMidYMid meet">
            
            <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
            fill="#000000" stroke="none">
            <path class="gjs-block-svg-path" 
            d="M223 1139 c-43 -13 -80 -60 -88 -112 -3 -23 -5 -213 -3 -422 3 -418
            2 -411 65 -452 25 -16 63 -18 443 -18 380 0 418 2 443 18 63 41 62 30 62 487
            0 380 -2 418 -18 443 -41 63 -32 62 -472 64 -226 1 -414 -2 -432 -8z m227
            -499 l0 -450 -107 0 c-96 0 -109 2 -130 22 l-23 21 0 406 c0 492 -14 451 152
            451 l108 0 0 -450z m617 428 l23 -21 0 -406 c0 -402 0 -405 -22 -428 -21 -23
            -22 -23 -290 -23 l-268 0 0 450 0 450 267 0 c260 0 267 -1 290 -22z"/>
            <path class="gjs-block-svg-path" 
            d="M253 983 c-18 -7 -16 -40 3 -47 9 -3 37 -6 64 -6 27 0 55 3 64 6 21
            8 21 40 0 48 -18 7 -113 7 -131 -1z"/>
            <path class="gjs-block-svg-path"  
            d="M253 823 c-18 -7 -16 -40 3 -47 32 -12 121 -6 134 9 23 27 -5 45 -69
            44 -31 0 -62 -3 -68 -6z"/>
            <path class="gjs-block-svg-path" 
            d="M253 663 c-18 -7 -16 -40 3 -47 32 -12 121 -6 134 9 23 27 -5 45 -69
            44 -31 0 -62 -3 -68 -6z"/>
            </g>
            </svg>
            <div class='gjs-fontFamily gjs-block-label'>Sidebar4</div>`,
        attributes: { },
        content: `     
                <div class="offcanvas offcanvas-start w-25" tabindex="-1" id="offcanvas" data-bs-keyboard="false" data-bs-backdrop="false">
                    <div class="offcanvas-header">
                        <h6 class="offcanvas-title d-none d-sm-block" id="offcanvas">Menu</h6>
                        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    </div>
                    <div class="offcanvas-body px-0">
                        <ul class="nav nav-pills flex-column mb-sm-auto mb-0 align-items-start" id="menu">
                            <li class="nav-item max-width">
                                <span href="#" class="pointer nav-link text-truncate">
                                    <i class="fs-5 bi-house"></i><span class="ms-1 d-none d-sm-inline">Home</span>
                                </span>
                            </li>
                            <li class="max-width">
                                <span href="#submenu1" data-bs-toggle="collapse" class="pointer nav-link text-truncate">
                                    <i class="fs-5 bi-speedometer2"></i><span class="ms-1 d-none d-sm-inline">Dashboard</span> </span>
                            </li>
                            <li class="max-width">
                                <span href="#" class="pointer nav-link text-truncate">
                                    <i class="fs-5 bi-table"></i><span class="ms-1 d-none d-sm-inline">Orders</span></span>
                            </li>
                            <li class="dropdown max-width">
                                <span href="#" class="pointer nav-link dropdown-toggle  text-truncate" id="dropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i class="fs-5 bi-bootstrap"></i><span class="ms-1 d-none d-sm-inline">Bootstrap</span>
                                </span>
                                <ul class="dropdown-menu text-small shadow" aria-labelledby="dropdown">
                                    <li><span class="pointer dropdown-item" href="#">New project...</span></li>
                                    <li><span class="pointer dropdown-item" href="#">Settings</span></li>
                                    <li><span class="pointer dropdown-item" href="#">Profile</span></li>
                                    <li>
                                        <hr class="dropdown-divider">
                                    </li>
                                    <li><span class="pointer dropdown-item" href="#">Sign out</span></li>
                                </ul>
                            </li>
                            <li class="max-width">
                                <span href="#" class="pointer nav-link text-truncate">
                                    <i class="fs-5 bi-grid"></i><span class="ms-1 d-none d-sm-inline">Products</span></span>
                            </li>
                            <li class="max-width">
                                <span href="#" class="pointer nav-link text-truncate">
                                    <i class="fs-5 bi-people"></i><span class="ms-1 d-none d-sm-inline">Customers</span> </soan>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col min-vh-100 p-4">
                            <!-- toggler -->
                            <button class="btn float-end" data-bs-toggle="offcanvas" data-bs-target="#offcanvas" role="button">
                                <i class="bi bi-arrow-right-square-fill fs-3" data-bs-toggle="offcanvas" data-bs-target="#offcanvas"></i>
                            </button>
                            <h3>Sample Content...</h3>
                            <p>Sriracha biodiesel taxidermy organic post-ironic, Intelligentsia salvia mustache 90's code editing brunch. Butcher polaroid VHS art party, hashtag Brooklyn deep v PBR narwhal sustainable mixtape swag wolf squid tote bag. Tote bag cronut semiotics, raw denim deep v taxidermy messenger bag. Tofu YOLO Etsy, direct trade ethical Odd Future jean shorts paleo. Forage Shoreditch tousled aesthetic irony, street art organic Bushwick artisan cliche semiotics ugh synth chillwave meditation. Shabby chic lomo plaid vinyl chambray Vice. Vice sustainable cardigan, Williamsburg master cleanse hella DIY 90's blog.</p>
                            <p>Ethical Kickstarter PBR asymmetrical lo-fi. Dreamcatcher street art Carles, stumptown gluten-free Kickstarter artisan Wes Anderson wolf pug. Godard sustainable you probably haven't heard of them, vegan farm-to-table Williamsburg slow-carb readymade disrupt deep v. Meggings seitan Wes Anderson semiotics, cliche American Apparel whatever. Helvetica cray plaid, vegan brunch Banksy leggings +1 direct trade. Wayfarers codeply PBR selfies. Banh mi McSweeney's Shoreditch selfies, forage fingerstache food truck occupy YOLO Pitchfork fixie iPhone fanny pack art party Portland.</p> Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia cor magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?
                        </div>
                    </div>
                </div>
        `
    });

} 

export default sidebar4;
